<template>
  <div
    class="d-flex align-center justify-space-between message_panel position-relative"
    :class="[panelClass]"
  >
    <slot></slot>
    <span v-if="isClose" class="close" @click="$emit('close')"><Close /></span>
  </div>
</template>
<script setup>
import Close from "@/components/icons/Close.vue";
import { defineEmits, defineProps } from "vue";
const props = defineProps({
  panelClass: {
    type: String,
    default: () => {
      return "info_panel";
    },
  },
  isClose: {
    type: Boolean,
    default: () => {
      return true;
    },
  },
});
const emit = defineEmits(["close"]);
</script>

<style lang="scss" scoped>


.message_panel {
  border-radius: 10px;
  font-weight: 400;
  color: #000;
  width: 100%;
  min-height: 50px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
    align-items: center;
    gap: 5px;
 
  &.info_panel{
    background: #e3f1ff;
  }
  .close {
    position: absolute;
    right: 4px;
    cursor: pointer;
    top: 4px;
  }
}
</style>